var map = {
	"./good.ts": "b3d0",
	"./help-center.ts": "f207",
	"./lang.ts": "4753",
	"./restock.ts": "8309",
	"./seller.ts": "597e",
	"./tagsView.ts": "3602",
	"./user.ts": "e451",
	"./view.ts": "e8ad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bcd5";